import type { ClerkErrorConfig } from '@/features/auth/shared/types/clerk';

export const CLERK_ERROR_CODE = {
  FORM_IDENTIFIER_NOT_FOUND: 'form_identifier_not_found',
  FORM_PASSWORD_INCORRECT: 'form_password_incorrect',
  FORM_CODE_INCORRECT: 'form_code_incorrect',
  VERIFICATION_EXPIRED: 'verification_expired',
  IDENTIFIER_ALREADY_SIGNED_IN: 'identifier_already_signed_in',
  SESSION_EXISTS: 'session_exists',

  EXTERNAL_ACCOUNT_NOT_FOUND: 'external_account_not_found',
  EXTERNAL_ACCOUNT_ALREADY_CONNECTED: 'oauth_account_already_connected',
  OAUTH_ACCESS_DENIED: 'oauth_access_denied',

  TOO_MANY_REQUESTS: 'too_many_requests',

  DEV_MONTHLY_EMAIL_LIMIT_EXCEEDED: 'dev_monthly_email_limit_exceeded',

  PASSWORD_PWNED: 'form_password_pwned',

  FORM_PARAM_FORMAT_INVALID: 'form_param_format_invalid'
} as const;

export const CLERK_OAUTH_STATUS = {
  VERIFIED: 'verified',
  NEEDS_ACCOUNT_CREATION: 'needs-account-creation'
} as const;

export const CLERK_RESOURCE_STATUS = {
  COMPLETE: 'complete',
  NEEDS_IDENTIFIER: 'needs_identifier'
} as const;

export const CLERK_STRATEGY = {
  RESET_PASSWORD_EMAIL_CODE: 'reset_password_email_code'
} as const;

export const CLERK_VERIFICATION_STATUS = {
  TRANSFERABLE: 'transferable'
} as const;

export const OAUTH_STATUS = {
  PROCESSING: 'processing',
  SIGN_IN_COMPLETE: 'sign-in-complete',
  SIGN_UP_COMPLETE: 'sign-up-complete',
  NEEDS_ACCOUNT_CREATION: 'needs-account-creation',
  OAUTH_ERROR: 'oauth-error',
  ALREADY_SIGNED_IN: 'already-signed-in',
  IDLE: 'idle'
} as const;

export const CLERK_ERROR_CONFIG: Record<string, ClerkErrorConfig> = {
  [CLERK_ERROR_CODE.FORM_IDENTIFIER_NOT_FOUND]: {
    type: 'email',
    messageKey: 'error.login.accountNotFound'
  },
  [CLERK_ERROR_CODE.FORM_PASSWORD_INCORRECT]: {
    type: 'password',
    messageKey: 'error.login.incorrectPassword'
  },
  [CLERK_ERROR_CODE.FORM_CODE_INCORRECT]: {
    type: 'code',
    messageKey: 'error.passwordResetSubmit.incorrectCode'
  },
  [CLERK_ERROR_CODE.VERIFICATION_EXPIRED]: {
    type: 'code',
    messageKey: 'error.passwordResetSubmit.expired'
  },
  [CLERK_ERROR_CODE.IDENTIFIER_ALREADY_SIGNED_IN]: {
    type: 'email',
    messageKey: 'error.auth.sessionExists'
  },
  [CLERK_ERROR_CODE.SESSION_EXISTS]: {
    type: 'email',
    messageKey: 'error.auth.sessionExists'
  },
  [CLERK_ERROR_CODE.FORM_PARAM_FORMAT_INVALID]: {
    type: 'email',
    messageKey: 'error.login.invalidEmail'
  },
  [CLERK_ERROR_CODE.PASSWORD_PWNED]: {
    type: 'password',
    messageKey: 'error.login.incorrectPassword'
  },
  [CLERK_ERROR_CODE.TOO_MANY_REQUESTS]: {
    type: 'general',
    messageKey: 'error.login.tooManyRequests'
  },
  [CLERK_ERROR_CODE.EXTERNAL_ACCOUNT_NOT_FOUND]: {
    type: 'email',
    messageKey: 'error.login.accountNotFound'
  },
  [CLERK_ERROR_CODE.EXTERNAL_ACCOUNT_ALREADY_CONNECTED]: {
    type: 'email',
    messageKey: 'error.login.accountAlreadyConnected'
  },
  [CLERK_ERROR_CODE.OAUTH_ACCESS_DENIED]: {
    type: 'email',
    messageKey: 'error.login.oauthCanceled'
  },
  [CLERK_ERROR_CODE.DEV_MONTHLY_EMAIL_LIMIT_EXCEEDED]: {
    type: 'general',
    messageKey: 'error.code.limitExceeded'
  }
};
